"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var util_1 = require("@aperza/util");
var appConfig = util_1.AppService.appConfig();
/**
 * Aperza Logo placeholder for various Aperza's sites.
 *
 * If the logoClassName is empty, the component will automatically detect the environment and apply the appropriate values.
 */
var Brand = function (props) {
    var brandConfig = function () {
        var logoClassName = 'logo';
        var url = appConfig.mainPage;
        var disableLogoLink = false;
        if (appConfig.isAperzaCatalog) {
            logoClassName = 'logo-catalog';
            url = "" + appConfig.searchWebHost + (appConfig.langCode == 'ja' ? '' : '/' + appConfig.langCode) + "/catalog";
        }
        else if (appConfig.isAperzaMarketplace || util_1.AppConfigService.shouldShowMarketplaceTopBanner()) {
            if (appConfig.langCode == 'en') {
                logoClassName = 'logo-ec-en';
            }
            else {
                logoClassName = 'logo-ec-ja';
            }
            url = "" + appConfig.mainPage;
        }
        else if (appConfig.serviceType == util_1.AppConfig.APERZA_NEWS) {
            logoClassName = 'logo-news';
            url = "//news" + appConfig.baseDomain;
        }
        else if (appConfig.isAperzaIdDomain) {
            logoClassName = 'logo-id';
            url = "" + appConfig.aperzaIdHost;
        }
        else if (appConfig.isAperzaAccountDomain) {
            logoClassName = 'logo-id';
            url = "" + appConfig.aperzaAccountHost;
        }
        else if (appConfig.isAperzaOrderDomain) {
            logoClassName = 'logo-ec-ja';
            url = "" + appConfig.marketplaceWebHost;
            if (util_1.AppConfigService.isOrderCheckout() || util_1.AppConfigService.isOrderRegister()) {
                disableLogoLink = true;
            }
        }
        else if (appConfig.isAperzaBusinessDomain) {
            logoClassName = 'logo-ec-ja';
            url = "" + appConfig.marketplaceWebHost;
            if (util_1.AppConfigService.isBusinessSignup()) {
                disableLogoLink = true;
            }
        }
        return {
            logoClassName: logoClassName,
            linkUrl: url,
            disableLink: disableLogoLink,
        };
    };
    var renderBrand = function () {
        var config = brandConfig();
        var logoClassName = props.logoClassName ? props.logoClassName : config.logoClassName;
        var url = props.linkUrl ? props.linkUrl : config.linkUrl;
        var disableLogoLink = props.disableLink ? props.disableLink : config.disableLink;
        if (disableLogoLink) {
            return (react_1.default.createElement("div", { className: "logo-container" },
                react_1.default.createElement("div", { className: logoClassName })));
        }
        else {
            return (react_1.default.createElement("div", { className: "logo-container" },
                react_1.default.createElement("a", { href: url, target: "_self" },
                    react_1.default.createElement("div", { className: logoClassName }))));
        }
    };
    return react_1.default.createElement(react_1.default.Fragment, null, renderBrand());
};
exports.Brand = Brand;
Brand.defaultProps = {
    disableLink: false,
};
exports.default = Brand;
